var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCreche = function SvgCreche(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#DBF6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7502 34.6213C48.7502 39.4676 44.8327 41.7139 40.0002 41.7139C35.1677 41.7139 31.2502 39.4676 31.2502 34.6213C31.2502 34.3452 31.2629 34.0769 31.2878 33.8163C31.2878 33.8163 27.75 31.185 30.5618 27.5954C33.3735 24.0058 37.2732 27.5954 37.2732 27.5954C38.1313 27.4045 39.048 27.3088 40.0002 27.3088C40.9524 27.3088 41.8691 27.4045 42.7273 27.5954C42.7273 27.5954 47 24.0058 49.625 27.5953C52.25 31.1849 48.7126 33.8163 48.7126 33.8163C48.7375 34.0769 48.7502 34.3452 48.7502 34.6213ZM43.2812 33.8911C43.8853 33.8911 44.375 33.4001 44.375 32.7942C44.375 32.1884 43.8853 31.6973 43.2812 31.6973C42.6772 31.6973 42.1875 32.1884 42.1875 32.7942C42.1875 33.4001 42.6772 33.8911 43.2812 33.8911ZM36.7188 33.8917C37.3228 33.8917 37.8125 33.4007 37.8125 32.7949C37.8125 32.189 37.3228 31.698 36.7188 31.698C36.1147 31.698 35.625 32.189 35.625 32.7949C35.625 33.4007 36.1147 33.8917 36.7188 33.8917Z",
    fill: "#36A094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8384 38.7443C30.6478 38.512 30.4947 38.3254 30.3746 38.2049C30.3746 38.2049 27.75 38.2049 27.75 40.9885C27.75 44.3475 30.3746 44.3475 30.3746 44.3475H31.25C27.75 51.3675 31.25 54 33.875 54C36.5 54 37.375 52.245 37.375 52.245H42.625C42.625 52.245 43.5 54 46.125 54C50.5 54 51.375 49.6125 48.75 44.3475H49.6246C49.6246 44.3475 52.2496 44.3475 52.2496 40.9885C52.2496 38.2049 49.6246 38.2049 49.6246 38.2049C49.4928 38.3281 49.3212 38.5337 49.1039 38.794C47.8791 40.2617 45.2017 43.47 39.9996 43.47C34.7154 43.47 32.0362 40.2044 30.8384 38.7443Z",
    fill: "#36A094"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreche, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/creche.de172ce2.svg";
export { ForwardRef as ReactComponent };